import React from 'react';

const NotAuthenticated = () => (
    <>
        <h3>Authentication Failed!</h3>
    </>
)

export default NotAuthenticated;